import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";

import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import MembershipPage from "./pages/MembershipPage";
import AboutPage from "./pages/AboutPage";
import PartnersPage from "./pages/PartnersPage";
import BlogsPage from "./pages/BlogsPage";
import ContactPage from "./pages/ContactPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import BookDoctorConsultantPage from "./pages/BookDoctorConsultantPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminTestimonialsPage from "./pages/AdminTestimonialsPage";
import AdminBookingsPage from "./pages/AdminBookingsPage";
import WhatsAppButton from "./components/WhatsAppButton";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AdminLayout from "./components/admin/AdminLayout";
import BlogDetails from "./pages/BlogDetails";

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen bg-cream flex flex-col">
      {isAdminRoute ? null : <Navbar />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route
              path="/knowledge-center/:id"
              element={<BlogDetails />}
            />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/book-consultant" element={<BookDoctorConsultantPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/testimonials" element={<AdminTestimonialsPage />} />
            <Route path="/admin/bookings" element={<AdminBookingsPage />} />
            
          </Route>
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        {isAdminRoute ? null : <WhatsAppButton />}
      </main>
      {isAdminRoute ? null : <Footer />}
    </div>
  );
}

export default App;
